module.exports = __webpack_public_path__ + "img/capsule-toy-orange.848a0f32.png";